export default __webpack_public_path__ + "498cf1adb42084b48a3a8f507ed119a7.png";